/**
 * Notepad dropdown menu data.
 *
 * The File menu is state-dependent (Save enabled when the user is signed in
 * and the doc isn't backed by a read-only src prop, etc.), so it's built by
 * `buildFileMenu`. The other menus never change so they're exported as
 * plain constants. A `dropDownData` default export is preserved for any
 * legacy callers that read the static shape.
 */

export function buildFileMenu({ canSave, hasNoteId }) {
  return [
    { type: 'item', disable: true, text: 'New' },
    { type: 'item', disable: true, text: 'Open...' },
    {
      type: 'item',
      disable: !canSave,
      text: 'Save',
      shortcut: hasNoteId ? 'Ctrl+S' : '',
    },
    {
      type: 'item',
      disable: !canSave,
      text: 'Save to My Notes',
    },
    { type: 'separator' },
    { type: 'item', disable: true, text: 'Page Setup...' },
    { type: 'item', disable: true, text: 'Print...' },
    { type: 'separator' },
    { type: 'item', text: 'Exit' },
  ];
}

export const editMenu = [
  { type: 'item', disable: true, text: 'Undo...' },
  { type: 'separator' },
  { type: 'item', disable: true, text: 'Cut' },
  { type: 'item', disable: true, text: 'Copy' },
  { type: 'item', disable: true, text: 'Paste' },
  { type: 'item', disable: true, text: 'Delete' },
  { type: 'separator' },
  { type: 'item', disable: true, text: 'Find...' },
  { type: 'item', disable: true, text: 'Find Next' },
  { type: 'item', disable: true, text: 'Replace...' },
  { type: 'item', disable: true, text: 'Go To...' },
  { type: 'separator' },
  { type: 'item', disable: true, text: 'Select All' },
  { type: 'item', text: 'Time/Date' },
];

export const formatMenu = [
  { type: 'item', text: 'Word Wrap' },
  { type: 'item', disable: true, text: 'Font...' },
];

export const viewMenu = [{ type: 'item', disable: true, text: 'Status Bar' }];

export const helpMenu = [
  { type: 'item', disable: true, text: 'Help Topics' },
  { type: 'item', disable: true, text: 'About Notepad' },
];

const dropDownData = {
  File: buildFileMenu({ canSave: false, hasNoteId: false }),
  Edit: editMenu,
  Format: formatMenu,
  View: viewMenu,
  Help: helpMenu,
};

export default dropDownData;
